/**
 * The outbound "Powered by Help Genie" / "Made magical by Help Genie" link —
 * distinct from the in-product footers that point at the customer's OWN genie
 * (those stay as-is). This one sends the click back to helpgenie.ai, tagged so
 * traffic a genie brings back is attributable to the genie that sent it.
 */
export function buildHelpGenieAttributionUrl(urlName?: string | null): string {
  const campaign = urlName ? encodeURIComponent(urlName) : "genie";
  return `https://helpgenie.ai/?utm_source=genie&utm_medium=powered-by&utm_campaign=${campaign}`;
}
